'use client'

import React from 'react'
import dynamic from 'next/dynamic'
import { useTranslations } from 'next-intl'

import { Offer } from '@/src/types/offers'
import { getBrandName } from '@/src/utils/buildUtils'
import { useSetLanguageCookie } from '@/src/utils/language'

const DesktopHomepageCarousel = dynamic(() => import('./homepageCarousel'), { ssr: true })
const MobileHomepageCarousel = dynamic(() => import('./mobileHomepageCarousel'), { ssr: true })

interface HomepageCarouselProps {
    offers: Offer[]
    locale: string
    isMobile: boolean
}

export const HomepageCarousel: React.FC<HomepageCarouselProps> = ({ offers, locale, isMobile }) => {
    useSetLanguageCookie()
    const tVariants = useTranslations('variants')
    const brandName = tVariants(getBrandName())

    if (!offers?.length) {
        return null
    }

    return isMobile ? (
        <MobileHomepageCarousel offers={offers} locale={locale} brandName={brandName} />
    ) : (
        <DesktopHomepageCarousel offers={offers} locale={locale} brandName={brandName} />
    )
}

export default HomepageCarousel
